import { useReduxState } from 'hooks';
import { Box } from 'components/common/box';
import { CoursePicture } from 'components/courses/common';
import { SettingsPictureScreen } from '.';

import type { CoursePicturePosition } from 'shared-types';

interface Props {
  picture: string;
  picturePosition: CoursePicturePosition;
  size: number;
}

const SettingsPicturePreview = ({ picture, picturePosition, size }: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="preview">
      <div className="preview-home">
        <SettingsPictureScreen
          contentHeight={160}
          contentStyle={{ padding: '15px 20px' }}
          headerHeight={12}
          subHeaderHeight={12}
          title={messages.settingsCoursePictureCourses}
        >
          <div className="tile">
            <Box padding={0} style={{ borderRadius: 5 }}>
              <div className="tile-inner">
                <div className="tile-picture">
                  <CoursePicture
                    position={picturePosition}
                    size={size}
                    url={picture}
                  />
                </div>
                <div className="tile-content">
                  <div className="tile-title" />
                  <div className="tile-info" />
                  <div className="tile-button" />
                </div>
              </div>
            </Box>
          </div>
        </SettingsPictureScreen>
      </div>

      <div className="preview-login">
        <SettingsPictureScreen
          contentHeight={172}
          headerHeight={12}
          subHeaderHeight={0}
          title={messages.settingsCoursePictureLogin}
          useLoginBackground={true}
        >
          <div className="login">
            <div className="login-picture">
              <CoursePicture
                position={picturePosition}
                size={size}
                url={picture}
              />
            </div>
            <div className="login-content">
              <Box padding={0} style={{ borderRadius: 5 }}>
                <div className="login-inner">
                  <div className="login-course">
                    <div className="login-title" />
                    <div className="login-description" />
                    <div className="login-description-alt" />
                  </div>
                  <div className="login-form">
                    <div className="login-input" />
                    <div className="login-input" />
                    <div className="login-button" />
                  </div>
                </div>
              </Box>
            </div>
          </div>
          <div className="login-footer" />
        </SettingsPictureScreen>
      </div>

      <style jsx>{`
        .preview {
          display: flex;
          flex-wrap: wrap;
          gap: 20px;
          margin-top: 20px;
        }
        .preview-home,
        .preview-login {
          width: 340px;
        }
        .tile {
          width: 74px;
        }
        .tile-picture {
          border-radius: 3px 3px 0 0;
          flex-grow: 0;
          flex-shrink: 0;
          height: 34px;
          overflow: hidden;
          position: relative;
          width: 100%;
        }
        .tile-content {
          height: 48px;
          padding: 9%;
        }
        .tile-title {
          background-color: #555;
          height: 5px;
          width: 80%;
        }
        .tile-info {
          background-color: #ddd;
          height: 3px;
          margin-top: 5px;
          width: 60%;
        }
        .tile-button {
          background-color: ${theme.mainColor};
          height: 6px;
          margin-top: 15px;
          width: 18px;
        }
        .login {
          align-items: center;
          display: flex;
          height: calc(100% - 10px);
          justify-content: center;
          position: relative;
        }
        .login-picture {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
        }
        .login-content {
          display: flex;
        }
        .login-inner {
          display: flex;
          gap: 10px;
        }
        .login-course {
          padding: 10px;
          width: 80px;
        }
        .login-title {
          background-color: #555;
          height: 5px;
          width: 40px;
        }
        .login-description {
          background-color: #ddd;
          height: 3px;
          margin-top: 7px;
          width: 60px;
        }
        .login-description-alt {
          background-color: #ddd;
          height: 3px;
          margin-top: 5px;
          width: 50px;
        }
        .login-form {
          border-left: 1px solid #eee;
          height: 50px;
          padding: 10px;
          width: 60px;
        }
        .login-input {
          background-color: #ddd;
          height: 6px;
          margin-bottom: 6px;
        }
        .login-button {
          background-color: ${theme.successColor};
          height: 6px;
        }
        .login-footer {
          background-color: white;
          height: 10px;
          width: 100%;
        }
      `}</style>
    </div>
  );
};

export default SettingsPicturePreview;
